import { Injectable } from '@angular/core';
import { groupBy, keyBy } from 'lodash';
import moment from 'moment';
import { MovementsByDay } from './dashboard-storage-movements.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardStorageMovementsMapperService {

  public toLineChartFormat({ movementsByDay, from, to }: { movementsByDay: MovementsByDay[], from: any, to: any }): any {

    const grouped = groupBy(movementsByDay, 'storageName');

    const result = [];
    for (const group of Object.keys(grouped)) {
      const movements = grouped[group];

      const map = keyBy(movements, 'date');
      const items = [];

      const date = moment(from);
      while (date.isSameOrBefore(to, 'day')) {
        const dateKey = date.format('YYYY-MM-DD');
        const item = map[dateKey];
        items.push(this.createChartItem(date, item, items));


        date.add(1, 'day');
      }

      result.push({
        name: group,
        series: items
      });
    }

    return result;
  }

  private createChartItem(date: moment.Moment, item: any, items: any[]): any {
    const dateKey = date.format('DD/MM');
    const formattedDate = date.format('DD/MM/YYYY');
    const formattedName = item && item.storageName ? `${item.storageName} • ${formattedDate}` : formattedDate;

    if (item) {
      return {
        name: dateKey,
        formattedName: formattedName,
        value: item.finalCount,
        item: item
      };
    }

    const previousItem = items[items.length - 1];
    if (previousItem) {
      const storageName = previousItem.item ? previousItem.item.storageName : '';
      return {
        name: dateKey,
        formattedName: `${storageName} • ${formattedDate}`,
        value: previousItem.value,
        item: previousItem.item
      };
    }

    return {
      name: dateKey,
      formattedName: formattedName,
      value: 0,
      item: null
    };

  }
}
